import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "../../../../lib/axios";
import TableComponent from '../../../../atoms/TableComponent/DataTable';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import { Box, Button, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'BankName', label: 'Bank', minWidth: 100 },
    { id: 'AccNo', label: 'Account No', minWidth: 100 },
    { id: 'Ifsc', label: 'Ifsc', minWidth: 100 },
    { id: 'Branch', label: 'Branch', minWidth: 100 },
    { id: 'Remark', label: 'Remark', minWidth: 100 },
    { id: 'Status', label: 'Status', minWidth: 100 }
];

export default function CourseMasterTable() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const [searchTerms, setSearchTerms] = useState({});
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetchBankMstData();
    }, []);

    const permissions = usePermissions("Bank Master");

    const { AddRec = "0" } = permissions || {};

    const handlePermittedClick = () => {
        if (AddRec === "1") {
            handleClick();
        }
    };

    const fetchBankMstData = async () => {
        try {
            const response = await axios.post('MstBank/getAllMstBankDashBoard', {
                start: 0,
                PageSize: 0,
                SearchText: ""
            });

            if (response.data.Status === 0) {
                const formattedData = response.data.Data.map(bank => ({
                    ...bank,
                    BankName: bank.BankName || '',
                    AccNo: bank.AccNo || '',
                    Ifsc: bank.Ifsc,
                    Branch: bank.Branch,
                    Remark: bank.Remark,
                    Status: bank.Status === null ? '' : (bank.Status == 1 ? 'Active' : 'Inactive')
                }));
                setRows(formattedData);

            } else {
                console.error('Error fetching bank master data:', response.data.Message);
            }
        } catch (error) {
            console.error('Error fetching bank master data:', error);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleClick = () => {
        navigate('/bank');
    };

    const handleHomeClick = () => {
        navigate('/dashboard');
    };

    const handleSearchChange = (columnId, value) => {
        setSearchTerms(prev => ({ ...prev, [columnId]: value }));
        setPage(0);
    };

    const filteredRows = React.useMemo(() => {
        return rows.filter(row => {
            return Object.entries(searchTerms).every(([columnId, term]) => {
                if (!term) return true;
                const value = row[columnId];
                if (typeof value === 'string') {
                    return value.toLowerCase().includes(term.toLowerCase());
                } else if (typeof value === 'number') {
                    return value.toString().includes(term);
                }
                return true;
            });
        });
    }, [searchTerms, rows]);

    const handleRowDoubleClick = (row) => {

        navigate('/bank', { state: { BankId: row.BankId, mode: 'view' } });
    };

    const handleLocationclick = () => {
        navigate("/masters/accounts")
    }

    const addButtonStyles = {
        background: AddRec === "1" ? "#635bff" : "rgba(0, 0, 0, 0.12)",
        color: AddRec === "1" ? "white" : "rgba(0, 0, 0, 0.26)",
        borderRadius: "50px",
        padding: "8px 20px",
        boxShadow: AddRec === "1" ? "0px 6px 15px rgba(0, 0, 0, 0.3)" : "none",
        transition: "background 0.3s ease",
        "&:hover": {
            background: AddRec === "1" ? "#524ccc" : "rgba(0, 0, 0, 0.12)"
        },
        "&:disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.12)",
            color: "rgba(0, 0, 0, 0.26)"
        }
    };

    const Filters = (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Tooltip
                title={AddRec !== "1" ? "You have no permission to add record" : ""}
                placement="top"
            >
                <span>
                    <Button
                        variant="contained"
                        onClick={handlePermittedClick}
                        size="small"
                        disabled={AddRec !== "1"}
                        sx={addButtonStyles}
                    >
                        <AddIcon /> New
                    </Button>
                </span>
            </Tooltip>
        </Box>
    );

    return (

        <TableComponent
            columns={columns}
            rows={rows}
            filteredRows={filteredRows}
            page={page}
            title="Accounts"
            titleMaster="Bank Master"
            rowsPerPage={rowsPerPage}
            FiltersJsx={Filters}
            handleRowDoubleClick={handleRowDoubleClick}
            handleSearchChange={handleSearchChange}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleClick={handleClick}
            handleHomeClick={handleHomeClick}
            handleLocationclick={handleLocationclick}
        />
    );
}